import React, {useEffect, useState}					from 'react';

import Input										from '../ressources/components/Input';
import Icon											from '../ressources/components/Icon';
import Modal										from '../ressources/components/Modal';
import Button										from '../ressources/components/Button';
import DeviceImage									from '../ressources/components/Device/DeviceImage';
import {SelectData}									from '../ressources/components/Select/interface';

import {useAppSelector, useAppDispatch}				from '../app/hooks';
import {deleteCompanyBundleApi, getCompanyBundleApi,
	postCompanyBundleApi, putCompanyBundleApi}		from '../redux/companyBundle/companyBundle';
import {CompanyBundle, PutCompanyBundleData}		from '../redux/companyBundle/interface';
import {InputValues}								from '../ressources/components/Input/interface';
import {LanguageNotification, LanguageType}			from '../ressources/language/type';

import {ft_genNotification, ft_pushNotification}	from '../ressources/functions/notification';
import ft_cssVar									from '../ressources/functions/getCssVar';
import {ft_formatPrice}								from '../ressources/functions/format';

import img_dotsVertical								from '../ressources/images/icon/dots-vertical.svg';
import img_settings									from '../ressources/images/icon/menu/settings.svg';
import img_leftArrow								from '../ressources/images/icon/arrow/left.svg';
import img_check									from '../ressources/images/icon/check.svg';
import img_trash									from '../ressources/images/icon/trash.svg';
import img_alert									from '../ressources/images/icon/alert-circle.svg';

import LANGUAGE										from '../ressources/language';


interface Props {
	onClose: () => void,
	shopId?: string
	forceBundle?: CompanyBundle
}

function ModalCompanyBundle(props: Props) {
	const dispatch = useAppDispatch();
	const companyBundle = useAppSelector(state => state.companyBundle.data);
	const load = useAppSelector(state => state.address.isLoadPut || state.address.isLoad);
	const user = useAppSelector(state => state.user.data);
	const lang = useAppSelector(state => state.settings.lang);
	const notificationId = useAppSelector(state => state.notifications.lastId);

	const [view, set_view] = useState<'home' | 'add' | 'edit'>('home');
	const [selected, set_selected] = useState<null | CompanyBundle>(null);
	const [name, set_name] = useState<InputValues>('');
	const [error, set_error] = useState<{[key: string]: string}>({});

	const [seeProperty, set_seeProperty] = useState('');

	const TEXTE = LANGUAGE(lang);

	const ACTIONS_LIST: SelectData[] = [
		{
			value:  'edit',
			render: <span className={'text-xs weight-500 gray-700'}>{TEXTE.settings.editAddress}</span>
		},
		{
			value:  'delete',
			render: <span className={'text-xs weight-500 error-600'}>{TEXTE.global.delete}</span>
		}
	];

	useEffect(() => {
		if (view === 'home')
			dispatch(getCompanyBundleApi(user));

		if ((view === 'home' || view === 'add') && !props.forceBundle)
			set_selected(null);
		set_name((selected && view === 'edit') ? selected.name : '');
		set_error({});
	}, [view]);

	useEffect(() => {
		if (props.forceBundle)
			set_selected(companyBundle.find(find => find._id === props.forceBundle?._id) || props.forceBundle);
	}, [props.forceBundle, companyBundle]);

	function addOrEditBundle(forceData?: PutCompanyBundleData) {
		if (view === 'edit' && !selected)
			return;

		const newError: {[key: string]: string} = {};
		if (!forceData) {
			if (!name)
				newError.name = 'required';

			set_error(newError);

			if (Object.keys(newError).length > 0)
				return;
		}

		const apiData: PutCompanyBundleData = forceData || {
			name,
			shopId: view === 'add' ? props.shopId : undefined
		};

		dispatch(selected ? putCompanyBundleApi({idBundle: selected._id, data: apiData, user}) : postCompanyBundleApi({data: apiData, user}))
		.then((response) => {
			let notificationType: keyof LanguageNotification = (view === 'add' ? 'addCompanyBundleSuccess' : 'editCompanyBundleSuccess');

			if (response.payload?.error) {
				notificationType = 'error';
				newError.name = TEXTE.order.bundle.nameExist;
				set_error(newError);
			}

			const notification = ft_genNotification(TEXTE, notificationType, img_settings, newError.name || name as string, notificationType === 'error' ? 'error' : 'success');
			ft_pushNotification(dispatch, notificationId, notification);

			if (!props.forceBundle && view !== 'edit')
				props.onClose();

			if (view === 'home')
				return dispatch(getCompanyBundleApi(user));
			set_view('home');
		});
	}

	function deleteBundle(bundleData: CompanyBundle) {
		dispatch(deleteCompanyBundleApi({idBundle: bundleData._id, user}))
		.then(() => {
			const notification = ft_genNotification(TEXTE, 'deleteAddressSuccess', img_settings, bundleData.name);
			ft_pushNotification(dispatch, notificationId, notification);
			set_view('home');
			set_selected(null);

			if (props.forceBundle)
				props.onClose();
		});
	}

	function renderAddOrEdit() {
		return (
			<Modal
				modalRight
				headerSeparation
				confirmLoad={load}
				confirmButtonDisabled={!name}
				onClose={() => set_view('home')}
				confirmButton={() => addOrEditBundle()}
				confirmButtonText={TEXTE.global.validAndSave}
				header={view === 'add' ? TEXTE.global.add : TEXTE.global.edit}
			>
				<div className={'settingsAddressBackToList'} onClick={() => set_view('home')}>
					<Icon icon={img_leftArrow} />
					{TEXTE.order.bundle.backToList}
				</div>

				<div className={'settingsAddressAddModal'}>
					<Input
						required
						value={name}
						error={error.name}
						onChange={set_name}
						title={TEXTE.order.bundle.name}
					/>
				</div>
			</Modal>
		);
	}

	function renderSelected() {
		if (!selected)
			return;

		const renderPropertiyLine = (propertyName: keyof LanguageType['global'], value: string) => {
			if (value)
				return <li className={'orderNewBasketPropertyLine'}>{`${TEXTE.global[propertyName]} : ${value}`}</li>;
		};

		const render: React.ReactElement[] = [];

		selected?.bundle.forEach((catalogData) => {
			const propertyOpen = seeProperty === catalogData._id;
			const isLegacy = catalogData.category.legacy;

			render.push(
				<div className={'orderNewBaskerItem'}>
					{isLegacy &&
						<Icon
							icon={img_alert}
							popup={TEXTE.order.bundle.legacyDevicePopup}
						/>
					}
					<DeviceImage
						imageFormat={'small'}
						catalog={catalogData}
						className={'orderNewBaskerItemImg'}
						style={{opacity: isLegacy ? 0.2 : 1}}
					/>
					<div className={'orderNewBaskerItemData'} style={{opacity: isLegacy ? 0.3 : 1}}>
						<span>{catalogData.category?.name}</span>

						<span
							className={`orderDataDeviceProperty ${propertyOpen ? 'open' : 'close'}`}
							onClick={() => set_seeProperty(propertyOpen ? '' : catalogData._id)}
						>
							{TEXTE.order.seeProperty}
						</span>
						{propertyOpen &&
							<ul>
								{renderPropertiyLine('state', catalogData.info.state)}
								{renderPropertiyLine('screenSize', catalogData.info.screenSize)}
								{renderPropertiyLine('processor', catalogData.info.processor)}
								{renderPropertiyLine('memory', catalogData.info.memory)}
								{renderPropertiyLine('stockage', catalogData.info.stockage)}
								{renderPropertiyLine('graphicCard', catalogData.info.graphicCard)}
								{renderPropertiyLine('network', catalogData.info.network)}
							</ul>
						}

						<div className={'orderNewBasketPriceLine'}>
							<span className={'text-sm weight-600 gray-800'}>{ft_formatPrice(catalogData.price)}<span className={'text-xs weight-400 gray-400'}>{`/${TEXTE.global.month}`}</span></span>
						</div>

					</div>

					{props.forceBundle &&
						<Icon
							icon={img_trash}
							onClick={() => {
								addOrEditBundle({
									action: 'remove',
									shopId: catalogData._id
								});
							}}
						/>
					}
				</div>
			);
		});

		return (
			<div className={'deviceModalAssignUser'}>
				{!props.forceBundle &&
					<div className={'settingsAddressBackToList'} onClick={() => set_selected(null)}>
						<Icon icon={img_leftArrow} />
						{TEXTE.order.bundle.backToList}
					</div>
				}

				<div className={'flex-center'}>
					<span className={'text-xl weight-600 gray-800'}>{selected?.name}</span>
					<div className={'flex'} />

					<Button
						absoluteRight
						absoluteHideIcon
						type={'tertiary-gray'}
						absolute={ACTIONS_LIST}
						onChangeAbsolute={(action) => {
							if (action === 'delete')
								return deleteBundle(selected);
							return set_view('edit');
						}}
					>
						<Icon icon={img_dotsVertical} />
					</Button>
				</div>
				<br />

				<div className={'deviceModalAssignUserBody'}>
					{render}
				</div>
			</div>
		);
	}

	function renderBundle() {
		const render: React.ReactElement[] = [];

		companyBundle?.forEach((bundleData) => {
			let found = false;
			let monthly = 0;

			bundleData.bundle.forEach((data) => {
				if (data._id === props.shopId)
					found = true;
				monthly += data.price || 0;
			});

			render.push(
				<div className={'settingAddressItem'} onClick={() => set_selected(bundleData)}>
					<div className={'settingAddressItemText'}>
						<span>{bundleData.name}</span>
						<span>{`${bundleData.bundle.length} ${TEXTE.global.devices}`}</span>
						{found &&
							<div className={'flex weight-600'} style={{marginTop: 8, gap: 6, alignItems: 'center'}}>
								<Icon
									icon={img_check}
									iconSize={16}
									iconColor={ft_cssVar('success-600')}
								/>
								{TEXTE.order.bundle.alreadyInBundle}
							</div>
						}
					</div>
					<div className={'flex-center'}>
						<span className={'text-sm weight-600 gray-800'}>{ft_formatPrice(monthly)}
							<span className={'text-xs weight-400 gray-400'}>{`/${TEXTE.global.month}`}</span>
						</span>
					</div>
				</div>
			);
		});

		return (
			<div className={'deviceModalAssignUser'}>
				<div className={'deviceModalAssignUserBody'}>
					{render}
				</div>
			</div>
		);
	}

	if (view === 'add' || view === 'edit')
		return renderAddOrEdit();

	return (
		<Modal
			modalRight
			headerSeparation
			confirmLoad={load}
			onClose={props.onClose}
			header={TEXTE.order.bundle.bundle}
			confirmButtonText={TEXTE.order.bundle[selected ? 'addToBundle' : 'addBundle']}
			confirmButton={
				props.forceBundle ?
					undefined
					:
					() => (selected ? addOrEditBundle({shopId: props.shopId}) : set_view('add'))
			}
		>
			{selected ? renderSelected() : renderBundle()}
		</Modal>
	);
}

export default ModalCompanyBundle;
